/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_List_Title_LeadInputs */

const en_pricing_list_title_lead = /** @type {(inputs: Pricing_List_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every price,`)
};

const pl_pricing_list_title_lead = /** @type {(inputs: Pricing_List_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wszystkie ceny,`)
};

/**
* | output |
* | --- |
* | "Every price," |
*
* @param {Pricing_List_Title_LeadInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const pricing_list_title_lead = /** @type {((inputs?: Pricing_List_Title_LeadInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_List_Title_LeadInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_pricing_list_title_lead(inputs)
	return en_pricing_list_title_lead(inputs)
});